import { Component, OnInit } from '@angular/core';
import { MessagesService } from 'app/services/messages.service';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss'],
    standalone: false
})
export class MessagesComponent implements OnInit {

  username;
  message;
  messages;
  messageSub;

  constructor(
    private messageService: MessagesService
  ) { }

  ngOnInit() {

    this.messageSub = this.messageService.getMessages().subscribe(res=>{
      this.messages = res;
      console.log('this is the message',res);
    });

  }
  ngOnDestroy() {
    this.messageSub.unsubscribe();
  }

  sendMessage(){
    if(this.message && this.username){
      let message = this.message;
      this.message = "";
      this.messageService.sendMessage(message, this.username);
    } else {
      alert('ADD A USERNAME YOU RAGING IDOT')
    }
  }

  deleteMessage(key){

    this.messageService.deleteMessage(key);

  }

}
